import { Link, useLocation } from "react-router-dom";
import { ClipboardList, Phone } from "lucide-react";
import { PHONE_TEL } from "@/lib/site";

export default function MobileCTA() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-line bg-ink/95 backdrop-blur md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={PHONE_TEL}
        data-testid="mobile-sticky-call-button"
        className="flex items-center justify-center gap-2 border-r border-line py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-white"
      >
        <Phone className="h-4 w-4" /> Call
      </a>
      <Link
        to="/contact"
        data-testid="mobile-sticky-consult-button"
        className="flex items-center justify-center gap-2 bg-white py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-ink"
      >
        <ClipboardList className="h-4 w-4" /> Consultation
      </Link>
    </div>
  );
}
